module.exports = __webpack_public_path__ + "static/media/centralSeatPremierOneSelected.04bc09e0.svg";